module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('list', {
    attrs: {
      "listTitle": _vm.$t('task.label'),
      "loading": _vm.loading || _vm.loadingFilters,
      "total": _vm.toolBatchTaskTotalTasks,
      "typesListAvailable": ['displayList'],
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'desc'
      }
    },
    on: {
      "change": _vm.onChange,
      "clearFilters": _vm.clearFilters
    }
  }, [_c('span', {
    staticClass: "btn btn--info",
    attrs: {
      "slot": "header-actions"
    },
    on: {
      "click": _vm.createTask
    },
    slot: "header-actions"
  }, [_vm._v(_vm._s(_vm.$t('task.create.label')))]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.toolBatchTaskStatuses), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t(("batch.statuses." + status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Ação"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.identifier),
      expression: "options.identifier"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.toolBatchTaskActions), function(action) {
    return _c('option', {
      key: action,
      domProps: {
        "value": action.identifier
      }
    }, [_vm._v(_vm._s(action.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Módulo"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleSelected),
      expression: "moduleSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.toolBatchTaskModules), function(module) {
    return _c('option', {
      domProps: {
        "value": ((module.type) + "." + (module.identifier))
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t(((module.type) + ".label"))) + " " + _vm._s(_vm.$t(((module.identifier) + ".label"))) + "\n          ")])
  })], 2)])], 1), _vm._v(" "), _vm._l((_vm.toolBatchTaskTasks), function(task, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-12@md"
    }, [_c('task-card', {
      attrs: {
        "task": task
      }
    }, [_c('li', {
      staticClass: "c-nav__item"
    }, [_c('a', {
      staticClass: "c-nav__link",
      class: {
        'is-disabled': task.status !== 'pending'
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showModal(task)
        }
      }
    }, [_vm._v("Cancelar")])])])], 1)
  }), _vm._v(" "), (!_vm.toolBatchTaskTasks.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhuma tarefa encontrada.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('modal-cancel', {
    on: {
      "option": function($event) {
        return _vm.cancelTask(_vm.cancelItem)
      }
    },
    model: {
      value: (_vm.cancelItemFlag),
      callback: function($$v) {
        _vm.cancelItemFlag = $$v
      },
      expression: "cancelItemFlag"
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b44960","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Task/List.vue
// module id = 2878
// module chunks = 0